/**
 * Maps practiceAreaKey → URL slug (for old route redirects)
 */
export const PRACTICE_AREA_SLUGS: Record<string, string> = {
  criminal: "criminal",
  personal_injury: "personal-injury",
  family: "family",
  litigation: "litigation",
  wills_estates: "estates",
  class_action: "class-action",
  corporate: "corporate",
  employment_labour: "employment",
  intellectual_property: "ip",
  tax: "tax",
  environmental: "environmental",
  bankruptcy_insolvency: "bankruptcy",
  administrative: "admin-law",
  construction: "construction",
  insurance: "insurance",
  entertainment: "entertainment",
  technology: "technology",
  immigration: "immigration",
  real_estate: "real-estate",
};

/** Reverse map: URL slug → practiceAreaKey (for redirects) */
export const SLUG_TO_PRACTICE_AREA: Record<string, string> = Object.fromEntries(
  Object.entries(PRACTICE_AREA_SLUGS).map(([k, v]) => [v, k])
);
